/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import Bootstrap from '../components/Bootstrap';
import PageContextProvider, { usePageContext } from '../components/PageContextProvider';
import { PAGE_CONTEXT } from '../constants/app-constants';
import SignUp from '../components/SignUp';
import Login from '../components/Login';
import Forgot from '../components/Forgot';

function PageSsoComp() {
  const { pageContext } = usePageContext();

  let ComponentToRender;
  switch (pageContext) {
    case PAGE_CONTEXT.SIGNUP:
      ComponentToRender = SignUp;
      break;
    case PAGE_CONTEXT.FORGOT:
      ComponentToRender = Forgot;
      break;
    default:
      ComponentToRender = Login;
  }
  return <ComponentToRender />;
}

export default function PageLogin({ auth0Config }) {
  return (
    <Bootstrap auth0Config={auth0Config}>
      <PageContextProvider>
        <PageSsoComp />
      </PageContextProvider>
    </Bootstrap>
  );
}

PageLogin.propTypes = {
  auth0Config: PropTypes.object,
};

PageLogin.defaultProps = {
  auth0Config: undefined,
};
